import { Link } from "react-router-dom";

export const ImpressumPage = () => {
  return (
    <main className="lpv2-legal-wrap">
      <section className="lpv2-legal-card">
        <h1>Impressum</h1>
        <p className="lpv2-legal-lead">
          Anbieter dieser Website und der Beschluss-APP für digitale Umlaufbeschlüsse in WEG- und
          Hausverwaltungen.
        </p>

        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          Emig Immobilien
          <br />
          An der Fahrt 13 | 55124 Mainz
          <br />
          Deutschland
        </p>

        <h2>Kontakt</h2>
        <p>
          E-Mail: <a href="mailto:mail@derumlaufbeschluss.de">mail@derumlaufbeschluss.de</a>
          <br />
          Website: <a href="https://www.derumlaufbeschluss.de">www.derumlaufbeschluss.de</a>
        </p>

        <h2>Inhalte des Angebots</h2>
        <p>
          Die Website informiert über die Softwarelösung „Der Umlaufbeschluss“ mit Funktionen für Beschlusserstellung,
          Abstimmung, Auswertung, Dokumententransfer und Integrationen (u. a. Facilioo). Über das Demoformular können
          Interessenten Testzugänge oder eine persönliche Produktdemo anfragen.
        </p>

        <h2>Haftung für Inhalte</h2>
        <p>
          Die Inhalte dieser Seiten werden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und
          Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden.
        </p>

        <h2>Haftung für Links</h2>
        <p>
          Diese Website kann Links zu externen Websites Dritter enthalten. Auf deren Inhalte haben wir keinen Einfluss.
          Für die Inhalte verlinkter Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
        </p>

        <h2>Urheberrecht</h2>
        <p>
          Die auf dieser Website veröffentlichten Inhalte, Grafiken und Werke unterliegen dem deutschen Urheberrecht.
          Vervielfältigung, Bearbeitung oder Verbreitung bedürfen der vorherigen schriftlichen Zustimmung des
          Rechteinhabers.
        </p>

        <div className="lpv2-legal-back">
          <Link to="/">Zurück zur Startseite</Link>
        </div>
      </section>
    </main>
  );
};
